export default __webpack_public_path__ + "static/media/icon_guide_expires.5514a2f5.svg";